module.exports = __webpack_public_path__ + "static/media/Trio Evocacion 3.3cbd8bac.jpg";